<div class="upperSection">
  <h2>{{devices[currentSensorIndex].label}}</h2>
  <div>
    @if(isSuperUser) {<mat-icon (click)="showDevStats = !showDevStats"
      style="margin-right: 5px; cursor: pointer;">insights</mat-icon>}
    <mat-icon>{{devices[currentSensorIndex].stream ? 'wifi' : 'wifi_off'}}</mat-icon>
  </div>
</div>
<div class="streaming-body">
  <div #streamViewport class="stream-viewport" [class.fullScreenContainer]="fullScreenMode"
    [class.imageContainer]="!fullScreenMode">

    @if (devices[currentSensorIndex].stream) {
    <div class="stream-shell" [class.image]="!fullScreenMode">
      <video [srcObject]="devices[currentSensorIndex].stream" autoplay playsinline muted class="fullscreen-image"
        #remoteVideo [class.video-hidden]="devices[currentSensorIndex].isStreamingLoading"
        style="aspect-ratio: 16/9; object-fit: cover; width: 100%; display: block; background-color: black;">
      </video>

      @if(devices[currentSensorIndex].isStreamingLoading) {
      <div class="stream-overlay stream-overlay_loading">
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
      </div>
      }
    </div>
    @if(showDevStats) {
    <div class="dev-stats-overlay">
      <div>⚙️ WEBRTC STATS</div>
      <div>RES: {{ streamStats.resolution }}</div>
      <div>FPS: {{ streamStats.fps }}</div>
      <div>BTR: {{ streamStats.bitrate }}</div>
      <div [style.color]="streamStats.loss > 0 ? '#ff4444' : '#00ff00'">
        PKT LOSS: {{ streamStats.loss }}
      </div>
    </div>
    }
    } @else {
    <div [ngStyle]="{'background-color': devices[currentSensorIndex].isStreamingLoading ? '#ffffff' : '#616161'}"
      style="color: aliceblue; width: 100%; border-radius: 0 0 5px 5px; border: 1px solid #e6e6e6; display: flex; justify-content: center; align-items: center; aspect-ratio: 16/9;">
      @if(devices[currentSensorIndex].streamingUnavailable) {
      STREAMING NON DISPONIBILE
      } @else if(devices[currentSensorIndex].isStreamingLoading) {
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
      }
    </div>
    }

    <div class="fullscreen" (click)="toggleFullScreen()"
      [ngClass]="fullScreenMode ? 'fullscreen_bigScreen' : 'fullscreen_smallScreen'">
      <mat-icon>{{fullScreenMode ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
    </div>
    <div class="arrow" [ngClass]="fullScreenMode ? 'arrow_left_bigScreen' : 'arrow_left_smallScreen'"
      *ngIf="currentSensorIndex" (click)="prevSensor()">
      <mat-icon>chevron_left</mat-icon>
    </div>
    <div class="arrow" [ngClass]="fullScreenMode ? 'arrow_right_bigScreen' : 'arrow_right_smallScreen'"
      *ngIf="(devices.length-1) !== currentSensorIndex" (click)="nextSensor()">
      <mat-icon>chevron_right</mat-icon>
    </div>
  </div>
</div>
